import {assert, qs, clamp, lerp, once} from './utils';
import {add_hotkeys} from './hotkeys';
import {render, html} from 'uhtml';

function get_opt(ob, name, default_) {
    const v = ob[name];
    return (typeof v == 'undefined') ? default_ : v;
}

class Param {
    constructor(name) {
        this.name = name;
    }

    set_value01(value) {
    }

    set_value(value) {
    }

    format_value() {
        return this.get_value().toFixed(3);
    }

    get_value() {
        return 0;
    }

    get_value01() {
        return 0;
    }

    set_default() {
    }
}

class FloatParam extends Param {
    constructor(name, opts) {
        super(name);
        this.min = get_opt(opts, 'min', 0);
        this.max = get_opt(opts, 'max', 1);
        this.default = get_opt(opts, 'default', this.min);
        this.set_default();
    }

    set_value01(value) {
        this.set_value(lerp(this.min, this.max, value));
    }

    set_value(value) {
        this.value = value;
    }

    get_value() {
        return this.value;
    }

    get_value01() {
        return (this.value - this.min) / (this.max - this.min);
    }

    set_default() {
        this.set_value(this.default);
    }
}

class EnumParam extends Param {
    constructor(name, opts) {
        super(name);
        this.options = opts.options;
        this.default = get_opt(opts, 'default', this.options[0]);
        this.set_default();
    }

    set_value01(value) {
        const n = this.options.length;
        const idx = clamp(~~(value * n), 0, n-1);
        this.set_value(this.options[idx]);
    }

    set_value(value) {
        this.value = value;
    }

    get_value() {
        return this.value;
    }

    get_value01() {
        return this.options.indexOf(this.value, this.options) / (this.options.length - 1);
    }

    set_default() {
        this.set_value(this.default);
    }

    format_value() {
        return this.value;
    }
}

class BoolParam extends Param {
    constructor(name, opts) {
        super(name);
        this.default = get_opt(opts, 'default', false);
        this.set_default();
    }

    set_value01(value) {
        this.set_value(value >= 0.5);
    }

    set_value(value) {
        this.value = value;
    }

    get_value() {
        return this.value;
    }

    get_value01() {
        return this.value ? 1 : 0;
    }

    format_value() {
        return this.value ? 'on' : 'off';
    }

    set_default() {
        this.set_value(this.default);
    }
}

let dragging = null;

function update_dragging(e) {
    const {el, param} = dragging;
    const r = el.getBoundingClientRect();
    const u = clamp((e.clientX - r.left) / (r.width - 1), 0, 1);
    param.set_value01(u);
    render_param(param);
}

function handle_event(e) {
    const el = e.target;

    if (e.type == 'mousedown') {
        const param = el.param;
        if (!param)
            return;

        if (e.ctrlKey) {
            param.set_default();
            render_param(param);
            e.preventDefault();
            return;
        }

        dragging = {el, param};
        update_dragging(e);
        e.preventDefault();
        document.addEventListener('mousemove', handle_event);
        document.addEventListener('mouseup', handle_event);
        document.addEventListener('mouseleave', handle_event);
    }

    else if (e.type == 'mousemove') {
        if (dragging) {
            update_dragging(e);
            e.preventDefault();
        }
    }

    else if (e.type == 'mouseup') {
        if (dragging) {
            update_dragging(e);
            e.preventDefault();
            document.removeEventListener('mousemove', handle_event);
            document.removeEventListener('mouseup', handle_event);
            document.removeEventListener('mouseleave', handle_event);
        }
    }

    else if (e.type == 'mouseleave') {
        if (dragging) {
            e.preventDefault();
            document.removeEventListener('mousemove', handle_event);
            document.removeEventListener('mouseup', handle_event);
            document.removeEventListener('mouseleave', handle_event);
        }
    }
}

function render_param(param) {
    const u = param.get_value01();
    const style = `width: ${100*u}%;`;
    return html.for(param)`
    <div class=param .param=${param} onmousedown=${handle_event}>
        <div class=param-slider style=${style}></div>
        <div class=param-value>${param.name} | ${param.format_value()}</div>
    </div>`;
}

function toggle_display(el, value) {
    if (!el)
        return;

    el.style.display = (el.style.display == 'none') ? value : 'none';
            add_hotkeys(document, {
                Tab() {
                    el.style.display = (el.style.display == 'none') ?  'flex' : 'none';
                },
            });
}

export class ParamList {
    constructor() {
        this.params = [];
        const el = this.el = qs('.param-list');
        this.toggle_visible();
        //el && add_hotkeys(document, {Tab: toggle_visible});

        this.render();
    }

    toggle_visible() {
        if (this.el)
            toggle_display(this.el, 'flex');
    }

    add_float(name, opts) {
        this.params[name] = new FloatParam(name, opts);
        this.render();
    }

    add_enum(name, opts) {
        this.params[name] = new EnumParam(name, opts);
        this.render();
    }

    add_bool(name, opts) {
        this.params[name] = new BoolParam(name, opts);
        this.render();
    }

    render() {
        if (this.el)
            render(this.el, html`${Object.values(this.params).map(render_param)}`);
    }

    get_value(name) {
        return this.params[name].get_value();
    }

    set_value(name, value) {
        const param = this.params[name];
        if (param) {
            param.set_value(value);
            render_param(param);
        }
    }

    toggle_value(name) {
        this.set_value(name, !this.get_value(name));
    }

    set_default() {
        Object.values(this.params).forEach(p => {
            p.set_default()
            render_param(p);
        });
    }
}
